module.exports = __webpack_public_path__ + "img/bo.bo88ba0b0.svg";